class MobileMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('[data-mobile-menu-close]').forEach((btn) =>
      btn.addEventListener('click', () => this.close())
    );
  }

  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu);
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const menu = document.querySelector('mobile-menu');
  if (!menu || typeof menu.open !== 'function') return;
  event.preventDefault();
  menu.open();
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('mobile-menu.is-open');
  if (menu && typeof menu.close === 'function') menu.close();
});
